/* global YT */

'use strict';

const WRAPPER_SELECTOR = '.js-background-video-wrapper';
const PLAY_BUTTON_SELECTOR = '[data-background-video-play-toggle]';
const MUTE_BUTTON_SELECTOR = '[data-background-video-mute-toggle]';
const RING_SELECTOR = '.feature-hero__video-ring-progress';
const IFRAME_SELECTOR = '.js-background-video';
const CIRCUMFERENCE = 2 * Math.PI * 18;
const MUTED_CLASS = 'video-is-muted';

export function init() {
    document.querySelectorAll(IFRAME_SELECTOR).forEach(async videoEl => {
        const wrapper = videoEl.closest(WRAPPER_SELECTOR);
        if (!wrapper) {
            return;
        }

        const muteButton = wrapper.querySelector(MUTE_BUTTON_SELECTOR);
        const playButton = wrapper.querySelector(PLAY_BUTTON_SELECTOR);
        if (!playButton) {
            return;
        }

        let ringInterval;

        const ring = document.querySelector(RING_SELECTOR);
        wrapper.classList.add(MUTED_CLASS);  // For consistency as need to start muted

        function handlePlayPause(ev) {
            switch (ev.type) {
                case 'play':
                    wrapper.classList.add('video-has-started');
                    playButton.classList.remove('is-paused');
                    playButton.setAttribute('aria-label', 'Pause video');
                    ringInterval = setInterval(() => {
                        const duration = videoEl.duration;
                        if (!duration) return;
                        const progress = videoEl.currentTime / duration;
                        ring.style.strokeDashoffset = -(CIRCUMFERENCE * progress);
                    }, 100);
                    break

                case 'pause':
                    playButton.classList.add('is-paused');
                    playButton.setAttribute('aria-label', 'Play video');
                    clearInterval(ringInterval);
                    break;
            }
        }

        videoEl.addEventListener('play', handlePlayPause);
        videoEl.addEventListener('pause', handlePlayPause);

        playButton.addEventListener('click', () => {
            if (videoEl.paused) {
                videoEl.play();
            } else if (videoEl.ended) {
                videoEl.play();
            } else {
                videoEl.pause();
            }
        });

        videoEl.play();
    });
}

export default { init };
